import authService from './authService';
import config from '../config';

const FAVORITES_API_PREFIX = '/api/v1/favorites';

/**
 * Adds a resource to favorites.
 * @param {string} resourceType - The backend resource type (e.g., exercise_definition).
 * @param {string} resourceId - The ID of the resource.
 * @returns {Promise<Object>}
 */
export const addFavorite = async (resourceType, resourceId) => {
  const url = `${config.API_BASE_URL}${FAVORITES_API_PREFIX}/${resourceType}/${resourceId}`;
  try {
    const response = await authService.authFetch(url, {
      method: 'POST',
    });
    if (!response.ok) {
      throw new Error(`Failed to add favorite: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('[favoritesApi] Error adding favorite:', error);
    throw error;
  }
};

/**
 * Removes a resource from favorites.
 * @param {string} resourceType - The backend resource type.
 * @param {string} resourceId - The ID of the resource.
 * @returns {Promise<Object>}
 */
export const removeFavorite = async (resourceType, resourceId) => {
  const url = `${config.API_BASE_URL}${FAVORITES_API_PREFIX}/${resourceType}/${resourceId}`;
  try {
    const response = await authService.authFetch(url, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error(`Failed to remove favorite: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('[favoritesApi] Error removing favorite:', error);
    throw error;
  }
};

/**
 * Gets all favorite IDs for a specific resource type.
 * @param {string} resourceType - The backend resource type.
 * @returns {Promise<Array<string>>} - Array of favorite IDs.
 */
export const getFavoritesByType = async (resourceType) => {
  const url = `${config.API_BASE_URL}${FAVORITES_API_PREFIX}/${resourceType}`;
  try {
    const response = await authService.authFetch(url);
    if (!response.ok) {
      // If 404, it might just mean no favorites exist yet or endpoint isn't ready, return empty
      if (response.status === 404) return [];
      throw new Error(`Failed to fetch favorites: ${response.status}`);
    }
    const data = await response.json();
    return data.favorite_ids || [];
  } catch (error) {
    console.error('[favoritesApi] Error fetching favorites:', error);
    return [];
  }
};

export default {
  addFavorite,
  removeFavorite,
  getFavoritesByType,
};